import type { Role } from "./types";

/**
 * A role is unused when it grants no permissions and no user or group has it directly.
 * Unknown membership and Keycloak's default roles (implicitly held by every user) never count as unused.
 */
export function isUnusedRole(role: Role): boolean {
  return role.permissionCount === 0 && role.hasMembers === false && role.keycloakDefault !== true;
}
